import { DocumentNode } from 'graphql';
import { graphql, OptionProps } from 'react-apollo';
import { ActivityQuery } from './queries';
import { Activity, ActivityInput, ActivityProps } from './types';

export function withActivityCore(query: DocumentNode, queryName: string) {
    if (!query) {
        throw new Error('No query specified for activity');
    }

    return graphql<
        any,
        { activity: { id: string; activity: Activity } },
        { input: { id: string } },
        ActivityProps
    >(query, {
        options: (props: ActivityInput) => ({
            variables: {
                input: {
                    id: props.id.toString()
                }
            }
        }),
        props: (props: OptionProps<ActivityInput, any>): ActivityProps => {
            const { data } = props;
            if (data) {
                const { error, loading } = data;

                const payload = data[queryName] as { activity: Activity };

                return {
                    activity:
                        payload && payload.activity
                            ? payload.activity
                            : undefined,
                    error,
                    loading
                };
            }
            throw new Error('No activity provided');
        }
    });
}

export default withActivityCore(ActivityQuery, 'activity');



// WEBPACK FOOTER //
// ./src/client/components/Strava/withActivity.tsx